import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { BASE_GRAPHQL_ENDPOINT } from "./graphql/client";
import { useDateRange } from "./utils/hooks/LoadingHook";
import { PAGE_ID_QUERY } from "./graphql/queries/pageQuery";

/**
 *  Properties needed for the query
 */
type QueryingProps = {
	publicationId: number;
	amount: (amount: any) => void;
}

/**
 *  Fetches all needed data from each page within the publication
 *
 * @param {number} publicationId The id of the publication which pages we want to use
 * @param {function} setLoaded checks if done
 * @returns {JSX.Element} empty
 */
export const QueryingForTotalPages = ({ publicationId, amount }: QueryingProps) => {
	const { previousWeek, today, loaded } = useDateRange(publicationId);
	const [added, setAdded] = useState(false);
	const [sendQuery, { data, loading, error }] = useLazyQuery(PAGE_ID_QUERY, {
		context: {
			uri: `${BASE_GRAPHQL_ENDPOINT}?publicationId=${publicationId}`
		},
		variables: {
			params1: {
				publicationId: publicationId,
				timeFrame: {
					begin: previousWeek,
					end: today
				},
				breakDownByPages: true
			},
			params: {
				timeframe: {
					begin: previousWeek,
					end: today
				}
			}
		},
	});

	useEffect(() => {
		if (loaded)
			sendQuery();
	}, [loaded]);

	useEffect(() => {
		if (!loading && !added && !error && data && data.Deprecated) {
			const pages = data.Deprecated.getPageViewCount;
			amount(pages.length);
			setAdded(true);
		}
	}, [data, loading, error]);

	if (loading)
		return null;

	if (error)
		return <>{error}</>;

	return null;
};

export default QueryingForTotalPages;